const version = "Ostkaka med drottningsylt 2026-06-23";

export default version;
